// Coordinates the PWA File Handler launch queue with the RestoreBackup component.
// When the OS opens a .json file in Optimize, the launchQueue consumer (main.tsx)
// stores the content here; RestoreBackup reads it on mount or on the custom event.
const STORAGE_KEY = 'optimize.launch-restore';
export const LAUNCH_RESTORE_EVENT = 'optimize:launch-restore';

export function storeLaunchFile(jsonText: string): void {
  sessionStorage.setItem(STORAGE_KEY, jsonText);
}

export function consumeLaunchFile(): string | null {
  const value = sessionStorage.getItem(STORAGE_KEY);
  if (value !== null) sessionStorage.removeItem(STORAGE_KEY);
  return value;
}
